 import { AppBar, Toolbar, Typography, ThemeProvider, createTheme } from "@mui/material";
import { useLocation } from "react-router-dom";
import colorConfigs from "../../configs/colorConfigs";
import sizeConfigs from "../../configs/sizeConfigs";

const theme = createTheme({
  palette: {
    background: {
      paper: '#fff',
    },
    text: {
      primary: '#173A5E',
      secondary: '#46505A',
    },
    action: {
      active: '#001E3C',
    },
    success: {
      main: '#009688',
      dark: '#00695f'
    },
  },
});

const legendaItens = [
  { cor: 'red', texto: 'Trinca' },
  { cor: 'orange', texto: 'Corrosão' },
  { cor: 'yellow', texto: 'Poros' },
  { cor: 'blue', texto: 'Abaulamento' },
];

const Topbar = () => {
  const location = useLocation();

  const exibirLegenda = location.pathname === "/MainLayout/3D";

  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${sizeConfigs.sidebar.width})`,
        ml: sizeConfigs.sidebar.width,
        boxShadow: "unset",
        backgroundColor: colorConfigs.topbar.bg,
        color: colorConfigs.topbar.color
      }}
    >
      <Toolbar>
        <ThemeProvider theme={theme}>
          {exibirLegenda && (
            <>
              <Typography variant="h6" sx={{ mr: 2 }}>
                Legenda: 
              </Typography>

              <section
                style={{
                  display: 'flex',
                  gap: '16px',
                  padding: '8px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  backgroundColor: '#fff'
                }}
              >
                <ul style={{ display: 'flex', listStyle: 'none', margin: 0, padding: 0, gap: '16px' }}>
                  {legendaItens.map((item, index) => (
                    <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <span
                        style={{
                          display: 'inline-block',
                          width: '20px',
                          height: '20px',
                          backgroundColor: item.cor,
                          border: '1px solid #000'
                        }}
                      />
                      <span>{item.texto}</span>
                    </li>
                  ))}
                </ul>
              </section>
            </>
          )}
        </ThemeProvider>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
